import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    // faPencilAlt, faTrash, faPlus,
    faCheckCircle,
    faPencilAlt,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import "./scenarios.css";
import i18n from "../i18n";

import ScenarioEdit from "./scenario-edit";
import ScenariosCheck from "./scenarios-check";
import { postAsync, getAsync } from "../utils/net";
import { distinctValues } from "../utils/lists";
import ExportDialog from "../designer/exportimport/exportdialog";
import ImportDialog from "../designer/exportimport/importdialog";
import { checkRole } from "../security/security";
import { ToastsStore } from "react-toasts";

export interface ScenariosTableProps { }
export interface ScenariosTableState {
    scenarios: any[];
    quickfind: string;
    typeValues: any[];
    marketValues: any[];
    loading: boolean;
    selectedItem: any;
    showEdit: boolean;
    showDelete: boolean;
    isNew: boolean;
    showCheck: boolean;
    showExport: boolean;
    showImport: boolean;

}

export class ScenariosTable extends React.Component<
    ScenariosTableProps,
    ScenariosTableState
    > {
    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private columns: Column[] = [
        {
            Header: i18n.Scenarios.Table.Name,
            accessor: "partitionKey"
        },
        {
            Header: i18n.Scenarios.Table.VirtualNode,
            accessor: "virtualNode"
        },
        {
            Header: i18n.Scenarios.Table.Category,
            accessor: "category"
        },
        {
            Header: i18n.Scenarios.Table.Market,
            accessor: "market"
        },
        {
            Header: i18n.Scenarios.Table.Type,
            accessor: "type"
        },
        {
            Header: i18n.Scenarios.Table.Intents,
            accessor: "intents"
        },
        {
            Header: i18n.Scenarios.Table.Entities,
            accessor: "entities"
        },
        {
            Header: i18n.Scenarios.Table.Keywords,
            accessor: "keywords"
        },
        {
            Header: i18n.Scenarios.Table.Channels,
            accessor: "channels"
        },
        {
            Header: i18n.Scenarios.Table.ScenarioDescription,
            accessor: "scenarioDescription"
        },
        {
            Header: i18n.Scenarios.Table.Languages,
            accessor: "languages"
        },
        {
            Header: i18n.Scenarios.Table.UserTypes,
            accessor: "userTypes"
        },
        {
            Header: i18n.Scenarios.Table.CheckedOutBy,
            accessor: "checkedOutBy"
        },
        {
            Header: i18n.Global.LastEdit,
            id: "timestamp",
            accessor: (row: any) => row._ts ? new Date(row._ts * 1000) : null,
            Cell: (row: any) => <span>{this.formatDate(row.value)}</span>
        },
        {
            Header: i18n.Global.LastEditBy,
            id: "changedBy",
            accessor: (value: any) => value.changedBy
        },
        {
            Header: "",
            filterable: false,
            show: checkRole("Scenarios.Change"),
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => this.onEdit(row.original)}
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </Button>
            )
        },
        {
            Header: "",
            filterable: false,
            show: checkRole("Scenarios.Change"),
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="danger"
                    onClick={() => this.onDelete(row.original)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            )
        },
    ];
    constructor(props: ScenariosTableProps) {
        super(props);
        this.state = {
            selectedItem: null,
            loading: false,
            showDelete: false,
            showEdit: false,
            isNew: false,
            showCheck: false,
            showExport: false,
            showImport: false,
            scenarios: [],
            typeValues: [],
            marketValues: [],
            quickfind: "",
        };
    }
    componentWillMount() {
        this.loadScenarios();
    }
    private formatDate(d: Date) {
        if (d) {
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} 
      ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
        } else {
            return "";
        }
    }

    render() {
        return (
            <Container fluid={true} className="scenarios-page page">
                <h1 className="page-header">{i18n.Scenarios.Title}</h1>
                <p>
                    <Button
                        color="warning"
                        size="sm"
                        onClick={() => this.onCheckConsistency()}
                    >
                        <FontAwesomeIcon icon={faCheckCircle} />
            &nbsp; {i18n.Scenarios.Form.CheckButton}
                    </Button>&nbsp;
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.showExport()}
                    >
                        {i18n.Scenarios.Form.ExportButton}
                    </Button>&nbsp;
          {checkRole("Scenarios.Change") && (
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.showImport()}
                    >
                        {i18n.Scenarios.Form.ImportButton}
                    </Button>)}
                </p>
                <p>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
                        <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
                    </InputGroup>
                </p>
                <ReactTable
                    noDataText={this.state.loading ? "Loading" : "No items found"}
                    data={this.list}
                    filterable={true}
                    columns={this.columns}
                    defaultFilterMethod={this.filterMethod}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
                <ScenarioEdit
                    item={this.state.selectedItem}
                    typeValues={this.state.typeValues}
                    marketValues={this.state.marketValues}
                    isOpen={this.state.showEdit}
                    isNew={this.state.isNew}
                    onCancel={() => this.onCancelEdit()}
                    onSave={model => this.onSave(model)}
                    scenarioList={this.state.scenarios}
                />
                <ExportDialog
                    isOpen={this.state.showExport}
                    onCancel={() => this.onCancelExport()}
                />
                <ImportDialog
                    isOpen={this.state.showImport}
                    onCancel={() => this.onCancelImport()}
                    onImport={(scenarios) => this.onImport(scenarios)}
                />
                <ScenariosCheck
                    isOpen={this.state.showCheck}
                    scenarios={this.state.scenarios}
                    onClose={() => this.closeCheck()}
                />
            </Container>
        );
    }

    private async loadScenarios() {
        this.setState({ loading: true });
        const reply = await getAsync("/api/designer/getscenarioslist");
        const payload = await reply.json();

        const marketValues = distinctValues(
            payload.map((x: any) => x.market).filter((x: any) => !!x)
        ).map(x => ({ id: x, name: x }));
        const typeValues = distinctValues(
            payload.map((x: any) => x.type).filter((x: any) => !!x)
        ).map(x => ({ id: x, name: x }));

        this.setState({
            scenarios: payload,
            marketValues,
            typeValues,
            loading: false
        });
    }

    private onEdit(item: any) {
        this.setState({ selectedItem: item, showEdit: true });
    }

    private async onDelete(model: any) {
        if (!confirm(i18n.Global.Delete.Confirm)) {
            return;
        }
       
        try {
            const reply = await postAsync("/api/designer/DeleteScenario", model);
            if (reply.ok) {
                ToastsStore.success(i18n.Scenarios.DeleteOk);
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadScenarios();
            } else {
                throw reply;
            }
        } catch (e) {
            ToastsStore.error(i18n.Scenarios.DeleteFailure);
        }
    }

    private onCancelEdit() {
        this.setState({ showEdit: false, selectedItem: null });
    }

    private onCancelExport() {
        this.setState({ showExport: false });
    }

    private onCancelImport() {
        this.setState({ showImport: false });
    }

    private async onImport(scenarios: any[]) {
        try {
            const reply = await postAsync("/api/designer/ImportScenarios", scenarios);
            if (reply.ok) {
                ToastsStore.success(i18n.Scenarios.ImportOk);

                this.setState({ showImport: false });
                this.loadScenarios();
            } else {
                throw reply;
            }
        } catch (e) {
            ToastsStore.error(i18n.Scenarios.ImportFailure);
        }
    }

    private async onSave(model: any) {
        try {
            const reply = await postAsync("/api/designer/SaveScenario", model);
            if (reply.ok) {
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadScenarios();
            } else {
                throw reply;
            }
        } catch (e) {
            ToastsStore.error(i18n.Scenarios.SaveFailure);
        }
    }

    private onCheckConsistency() {
        this.setState({ showCheck: true });
    }

    private showExport() {
        this.setState({ showExport: true });
    }

    private showImport() {
        this.setState({ showImport: true });
    }

    private closeCheck() {
        this.setState({ showCheck: false });
    }

    private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            quickfind: e.target.value,
        })
    }

    private get list() {
        return this.state.scenarios
            .filter(this.state.quickfind
                ? item => this.columns.some(col =>
                    this.filterMethod({ id: col.accessor, value: this.state.quickfind }, item))
                : item => true)
    }
}



// WEBPACK FOOTER //
// ./src/scenarios/scenarios.tsx